import { Injectable } from '@angular/core';
import { STORAGE_TRACK } from './constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  constructor(private http: HttpClient) {}

  track(key, value) {
    // try {
    //   const tracking = JSON.parse(localStorage.getItem(STORAGE_TRACK) || `{}`);
    //   tracking[key] = value;
    //   localStorage.setItem(STORAGE_TRACK, JSON.stringify(tracking))
    // } catch(e) {
    //   console.warn('Cant save tracking values', e)
    // }
  }

  pageView(page_path?, accountId?)
  {
      // if (accountId == 1)
      // {
      //   // google tag manager for polyvinyl
      //   (<any>window).dataLayer && (<any>window).dataLayer.push({ 'event': 'page_view', 'page_path': page_path });
      // }
      // else
      // {
      //     // google gtag for everyone else
      //     (<any>window).gtag && (<any>window).gtag('event', 'page_view', {
      //       'page_path': page_path,
      //     });
      // }

      // // Facebook Pixel
      // (<any>window).fbq && (<any>window).fbq('track', 'PageView')
  }


  // ############################################################################# BEGIN EVENT ########################################################
  event(name: string, accountId?: number, data?: any)
  {
      // PV uses Google Tag Manager
      if (accountId == 1)
      {
            // #1200 Google Tag Manager for analytics and conversions

                  var transaction_total = 0;

                  if (name == "purchase")
                  {
                      transaction_total = data.value;

                      if (data.tax && data.tax > 0)
                      {
                        transaction_total = transaction_total + data.tax;
                      }

                      if (data.shipping && data.shipping > 0)
                      {
                        transaction_total = transaction_total + data.shipping;
                      }
                  }

                  var ecommerceJson = {
                    'transaction_id': (name == 'purchase') ? data.transaction_id : undefined,
                    'value': transaction_total ? transaction_total : data.value,
                    "tax": data.tax ? data.tax : undefined,
                    "shipping": data.shipping ? data.shipping : undefined,
                    'currency': (name != "search") && data.value ? 'USD' : undefined,
                    'items': data.items ? data.items : undefined
                  }

                  var conversionJson = {
                          'event': name,

                          // events: purchase, add_to_cart, add_shipping_info, add_payment_info, begin_checkout, view_item
                          'ecommerce': (name != 'search' && name != 'select_promotion') ? ecommerceJson : undefined,

                          // event: search
                          "search_term": (name == "search" && data.search_term) ? data.search_term : undefined,

                          // event: select_promotion
                          "promotion_name": (name == "select_promotion") ? data.promotion_name : undefined
                  };


                  // push values to dataLayer to register with Google Analytics and Google Ads conversions
                  (<any>window).dataLayer && (<any>window).dataLayer.push(conversionJson);

                  this.http.post(`/api/payment/google-conversion-log`, { data: conversionJson, event: name })
                    .subscribe(x => {
                      console.log('GTAG', x);
                    });

      }
      else  // accountId != 1, everyone else has their old gtag
      {
            // THIS is a call to gtag, where it's a structured json data and should count towards GA4
            (<any>window).gtag && (<any>window).gtag('event', name, data);

            this.http.post(`/api/payment/google-conversion-log`, { data: data, event: name })
              .subscribe(x => {
                console.log('GA4', x);
              });
      }

      // Send data to FACEBOOK/META Pixel!
      var fbData = {};
      try
      {
          if (name == 'search')                                                                       // ### SEARCH / Search
          {
              name = 'Search';

              fbData = {
                search_string: data.search_term
              };

              (<any>window).fbq && (<any>window).fbq('track', name, fbData);
          }
          else if (name == 'begin_checkout')                                                          // ### BEGIN_CHECKOUT / InitiateCheckout
          {
              name = 'InitiateCheckout';

              fbData =  {
                contents: data.items.map(i => ({
                  id: i.item_id,
                  quantity: i.quantity,
                })),
                num_items: data.items.reduce((num, i) => num + i.quantity, 0),
                value: data.items.reduce((num, i) => num + (i.quantity * i.price), 0),
                currency: 'USD',
              };

              (<any>window).fbq && (<any>window).fbq('track', name, fbData);
          }
          else if (name == 'checkout_progress')                                                      // ### CHECKOUT_PROGRESS / AddPaymentInfo
          {
              name = 'AddPaymentInfo';

              if (data.checkout_step > 1)
              {
                  (<any>window).fbq && (<any>window).fbq('track', name)
              }
          }
          else if (name == "purchase")                                                               // ### PURCHASE / Purchase
          {
              name = 'Purchase';

              fbData = {
                content_ids: data.items ? data.items.map(i => i.item_id) : undefined,
                contents: data.items.map(i => ({
                  id: i.item_id,
                  quantity: i.quantity,
                })),
                value: data.items.reduce((num, i) => num + (i.quantity * i.price), 0),
                currency: 'USD'
              };

              (<any>window).fbq && (<any>window).fbq('track', name, fbData);
          }
          else if (name == "add_to_cart")                                                           // ### ADD_TO_CART / AddToCart
          {
              name = 'AddToCart';

              fbData = {
                content_ids: data.items ? data.items.map(i => i.item_id) : undefined,
                contents: data.items.map(i => ({
                  id: i.item_id,
                  quantity: i.quantity,
                })),
                value: data.value,
                currency: data.currency,
              };

              (<any>window).fbq && (<any>window).fbq('track', name, fbData);
          }
          else if (name == "view_item")
          {
              name = 'ViewContent';

              fbData = {
                content_name: data.items && data.items[0].item_name ? data.items[0].item_name : undefined,
                content_ids: data.items && data.items[0].item_id ? data.items[0].item_id : undefined,
                contents: data.items && data.items[0].item_id ? data.items[0].item_id.map(i => ({'id': `${i}`, 'quantity': '1'})) : undefined
              };

              (<any>window).fbq && (<any>window).fbq('track', name, fbData);
          }
          else { name = ''; }

          if (name != '')
          {
              this.http.post(`/api/payment/meta-conversion-log`, { data: fbData, event: name })
                .subscribe(x => {
                  console.log('meta', x);
                });
          }
      }
      catch(e)
      {
          //console.warn('fbq err - ', name, data);
      }
  }

  // ############################################################################# END EVENT ########################################################

  lead(referrer: string) {
    (<any>window).fbq && (<any>window).fbq('track', 'Lead', { content_name: referrer });
  }

  clearTracking() {
    localStorage.setItem(STORAGE_TRACK, `{}`)
  }
}